module.exports = __webpack_public_path__ + "static/jam2-bd1f415f8a156622ada85d6c6e2e9d28.svg";